/**
 * SimulationResultSequence
 * @class
 */
class SimulationResultSequence {

  /**
   * @instance
   * @param _$el {HTMLElement}
   */
  constructor(_$el) {
    this.$$before = _$el.getElementsByClassName('js-simulation-result-before');
    this.$$after  = _$el.getElementsByClassName('js-simulation-result-after');
    this.$batch   = _$el.getElementsByClassName('js-simulation-result-batch')[0];

    this.beforeW = _.map(this.$$before, (_$before) => {
      return _$before.dataset.graphwidth;
    });
    this.afterW = _.map(this.$$after, (_$after) => {
      return _$after.dataset.graphwidth;
    });
  }

  /**
   * @instance
   */
  getSequences() {
    return [
      {
        e: this.$$before[0],
        p: {
          width: this.beforeW[0],
        },
        o: { duration: 800, easing: 'easeOutCubic', delay: 1000 },
      },
      {
        e: this.$$before[1],
        p: {
          width: this.beforeW[1],
        },
        o: { duration: 800, easing: 'easeOutCubic', sequenceQueue: false },
      },
      {
        e: this.$$after[0],
        p: {
          width: this.afterW[0],
        },
        o: { duration: 800, easing: 'easeOutCubic', delay: 500 },
      },
      {
        e: this.$$after[1],
        p: {
          width: this.afterW[1],
        },
        o: { duration: 800, easing: 'easeOutCubic', sequenceQueue: false },
      },
      {
        e: this.$batch,
        p: {
          opacity: 1,
        },
        o: { duration: 300, easing: 'linear' },
      },
      {
        e: this.$batch,
        p: {
          translateY: 50,
        },
        o: { duration: 800, easing: 'easeOutBounce' },
      },
    ]
  }

}

/**
 * class exports
 */
module.exports = SimulationResultSequence;



/** WEBPACK FOOTER **
 ** ./webpack/requires/view/ui/animations/simulation-result-sequence.js
 **/